import { createVNode as _createVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/close.svg'
import _imports_1 from '@/assets/img/exclamation_point.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-c0b65350")

_pushScopeId("data-v-c0b65350")
const _hoisted_1 = { class: "_clickBlocker" }
const _hoisted_2 = { class: "genericModalContent text-center" }
const _hoisted_3 = { class: "d-flex justify-content-end" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "mt-3"
}, null, -1)
const _hoisted_5 = { class: "form-group squareInputContainer withLabel mt-4" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createBlock("div", {
    class: "__modalsContainer __show",
    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('close')))
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", {
          class: "confirm-div",
          onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent","stop"]))
        }, [
          _createVNode("div", _hoisted_3, [
            _createVNode("img", {
              src: _imports_0,
              class: "closeIcon",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
            })
          ]),
          _hoisted_4,
          _createVNode(_component_localized_text, {
            class: "errore fs_24 fw_700 d-block mb-2",
            localizedKey: "app_attenzione",
            text: "Attenzione!"
          }),
          _createVNode(_component_localized_text, {
            localizedKey: "app_perchevuoisegnalarequestocontenuto",
            text: "Perché vuoi segnalare questo contenuto?"
          }),
          _createVNode("div", _hoisted_5, [
            _createVNode("label", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "app_inserisciUnaMotivazione",
                text: "Inserisci una motivazione",
                class: "fs_12 grey"
              })
            ]),
            _withDirectives(_createVNode("input", {
              type: "text",
              class: "genericInput squareInput",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.note = $event))
            }, null, 512), [
              [_vModelText, _ctx.note]
            ])
          ]),
          _createVNode("button", {
            class: "genericButton bgPurple w-100 mt-5",
            disabled: _ctx.disabled,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.confirm()))
          }, [
            _createVNode(_component_localized_text, {
              localizedKey: "app_segnala",
              text: "Segnala",
              class: "fs_13 white"
            })
          ], 8, ["disabled"])
        ])
      ])
    ])
  ]))
})